import PropTypes from 'prop-types';
import { Icon } from '@evertrue/et-components';

const ThreadIndicator = ({ threadCount }) => {
  return (
    <span className="outreach-card-thread-count">
      <span>{threadCount}</span>
      <Icon icon="email-received-outreach" className="email-thread-icon" iconKit="gt2"></Icon>
    </span>
  );
};

ThreadIndicator.propTypes = {
  threadCount: PropTypes.number,
};

export default ThreadIndicator;
